import { co2 } from './common';

export default {
  'consumption.co2': `${co2} utslipp kombinert`,
  'consumption.energy': 'Strømforbruk i kombinert testsyklus',
  'consumption.fuel': 'Drivstofforbruk kombinert',
  'footnotes.local': '',
  'footnotes.wltp': `De angitte verdiene er beregnet i henhold til foreskrevne måleprosedyrer. Det dreier seg om "WLTP-${co2}-verdier“ iht. § 2 nr. 3 Gjennomføringsforordning (EU) 2017/1153. Drivstofforbruket er beregnet på basis av disse verdiene. Strømforbruket ble beregnet i samsvar med forordning 683/2008/EF. Verdiene gjelder ikke ett enkelt kjøretøy og inngår ikke i tilbudet, men er kun referanseverdier for sammenligning mellom forskjellige modellvarianter. Verdiene varierer avhengig av valgt tilleggsutstyr og kan være forskjellig fra de endelige verdiene til den bestilte eller utleverte bilen. Verdiene påvirkes også av forskjellige faktorer som f.eks. personlig kjørestil, forhold i omgivelsene og egenskaper ved den aktuelle kjøreruten. WLTP-verdiene er ihht fabrikkstandardutstyrt bil.`,
  'footnotes.nedc': '',
  'footnotes.emissions.appendix':
    'Vennligst kontakt din autoriserte Mercedes-Benz forhandler for mer informasjon om forbruks- og utslippsdata.',
  'search.input.label': 'Ditt søkeord/Online-kode konfigurator',
  'search.result.buy-online': 'Kjøp på nettet',
  'search.results': 'Ingen søkeresultat ble funnet | {count} søkeresultat | {count} søkeresultater',
  'search.results.backup': 'Ingen eksakte treff funnet. Se relaterte sider:',
  'search.results.count': '{count} søkeresultater',
  'search.results.none.summary':
    'Det er ingen søkeresultater tilgjengelig for dette søkeordet. Prøv igjen med et annet begrep.',
  'search.show-more': 'Vis mer',
  'search.unavailable': 'Søk er for øyeblikket ikke tilgjengelig.',
  'search.result.new': 'Ny',

  'search.result.consumption': 'Forbruk',

  'input.placeholder': 'Ditt søkeord/Online-kode konfigurator',

  'suggestions.all_search_results': 'Alle søkeresultater',
  'suggestions.all_search_results_for': 'Vis alle resultater for',
  'suggestions.in': 'i',

  all: 'Alle',
  UCOS: 'Bruktbiler Online Store"',
  PASSENGER_CARS: 'Personbil',
  VANS: 'Varebiler',
  NCOS: 'Nye biler Online Store',
  VIDEO: 'Videoer',
  DEALER_LOCATOR: 'Forhandlersøk',
  CONFIGURATOR: 'Konfigurator',
  TEST_DRIVE: 'Prøvekjøring',
  VEHICLE_SEARCH: 'Bruktbilsøk',
  COLLECT: 'Collection og tilbehør',
  CONNECT: 'Mercedes me Store',
  ACCESSORIES: 'Biltilbehør',

  'watch.video': 'Se videoen',
  'input.recently': 'Nylig søkte',
  'input.help.title': 'Hva bør du se etter?',
  'input.help.text':
    'Søk ved å bruke kjøretøytyper, modeller, konfigurasjonskoder eller søk etter tilbehør, andre produkter og informasjon',

  // No results found
  'support.check': 'Sjekk etter skrivefeil eller prøv igjen med et annet søkeord.',
  'support.no.results': 'Det finnes ingen søkeresultater for dette søkeordet.',
  'support.no.results.term': 'Finner ingen resultater.',
  'support.chat': 'Finner du ikke det du leter etter?Bruk vår.',
  'support.chat.with.us': 'Online chat-tjeneste.',
};
